// extracted by mini-css-extract-plugin
module.exports = {"imageTextPair":"style_imageTextPair__3WDCA","goofy":"style_goofy__L_brT","image":"style_image__1VQf1","paragraphGroup":"style_paragraphGroup__20jUi"};